import { render, staticRenderFns } from "./Giftcards.vue?vue&type=template&id=666ba822&scoped=true&lang=pug"
import script from "./Giftcards.vue?vue&type=script&lang=ts"
export * from "./Giftcards.vue?vue&type=script&lang=ts"
import style0 from "./Giftcards.vue?vue&type=style&index=0&id=666ba822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666ba822",
  null
  
)

export default component.exports